import { actionCreator } from '@blink/components/src/utils';

import {
    GET_ME,
    GET_ORGANIZATION_MEMBERS,
    SET_ME,
    SET_ME_LOADING_FALSE,
    SET_ORGANIZATION_MEMBERS,
    SET_ORGANIZATION_MEMBERS_LOADING_FALSE,
    SET_USER_LOCKED,
    SET_USER_RESTRICTION,
} from './constants';

import { Me, Member } from '@/shared/api/organization';

export const getMeAction = () => actionCreator(GET_ME);

export const setMeAction = (payload: Me) => actionCreator(SET_ME, payload);

export const setUserLockedAction = (payload: boolean) => actionCreator(SET_USER_LOCKED, payload);

export const setMeLoadingFalseAction = () => actionCreator(SET_ME_LOADING_FALSE);

export const getOrganizationMembersAction = (payload: number) =>
    actionCreator(GET_ORGANIZATION_MEMBERS, payload);

export const setOrganizationMembersAction = (payload: Member[]) =>
    actionCreator(SET_ORGANIZATION_MEMBERS, payload);

export const setOrganizationMembersLoadingFalseAction = () =>
    actionCreator(SET_ORGANIZATION_MEMBERS_LOADING_FALSE);

export const setRestrictionAction = () => actionCreator(SET_USER_RESTRICTION);
